import styles from './Logo.module.css';

/**
 * Monograma Movez (do Claude Design) + wordmark opcional. O traço usa
 * var(--volt) para acompanhar o tema ativo.
 */
export default function Logo({ size = 36, withWordmark = true }) {
  return (
    <span className={styles.logo}>
      <svg width={size} height={size} viewBox="225 65 672 205" fill="none" aria-label="Movez">
        <path
          d="M 557 168 L 549 156 L 472 87 L 452 78 L 427 78 L 402 91 L 235 251 L 275 253 L 288 248 L 405 132 L 433 109 L 443 108 L 457 113 L 539 182 L 551 181 Z"
          fill="var(--volt)"
        />
        <path
          d="M 887 224 L 767 98 L 732 80 L 706 80 L 675 94 L 574 204 L 554 220 L 531 216 L 460 150 L 447 148 L 438 156 L 439 168 L 514 243 L 535 252 L 559 252 L 582 241 L 692 122 L 707 114 L 727 113 L 743 120 L 850 228 L 881 230 Z"
          fill="var(--volt)"
        />
      </svg>
      {withWordmark && <span className={styles.wordmark}>movez</span>}
    </span>
  );
}
